<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/search/black</title>
    <g id="atoms/icons/30x30/search/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M12.25,3 C17.2205627,3 21.25,7.02943725 21.25,12 C21.25,14.2528828 20.4222285,16.3124291 19.0542401,17.8910846 L26.4319805,25.267767 C26.8225048,25.6582912 26.8225048,26.2914562 26.4319805,26.6819805 C26.0414562,27.0725048 25.4082912,27.0725048 25.017767,26.6819805 L17.5847096,19.2492422 C16.0918626,20.3496661 14.2468781,21 12.25,21 C7.27943725,21 3.25,16.9705627 3.25,12 C3.25,7.02943725 7.27943725,3 12.25,3 Z M12.25,5 C8.38400675,5 5.25,8.13400675 5.25,12 C5.25,15.8659932 8.38400675,19 12.25,19 C16.1159932,19 19.25,15.8659932 19.25,12 C19.25,8.13400675 16.1159932,5 12.25,5 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
